<main class="page_404">
  <div class="grid-container">
    <div class="row">
      <div class="col-12 text-center">
        <div class="row">
          <div class="col-10 offset-1 text-center">
            <div class="four_zero_four_bg">
              <h1 class="text-center">404</h1>
            </div>
            <div class="content_box_404">
              <h3 class="h2">Look like you're lost</h3>
              <p>The page you are looking for is not available!</p>
              <button class="controlButton" (click)="goToSignin()">
                Go to sign-in page
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>